import { useEffect } from "react";
import { ParamListBase, useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";

/**
 * Run the provided callback every time a screen loses focus.
 *
 * @param {Function} callback
 * @author [Alex McCabe](https://github.com/alexmccabe)
 */
export default function useOnScreenBlur(callback: () => void) {
  const navigation = useNavigation<StackNavigationProp<ParamListBase>>();

  useEffect(() => {
    const unsubscribe = navigation.addListener("blur", callback);

    return unsubscribe;
  }, [navigation]);
}
